import Vue from "vue";
import Router from "vue-router";
const _import = require("./_import_" + process.env.NODE_ENV);
import courseRouter from "./courseRouter";
import Login from "@/views/login";
import Register from "@/views/Register";
import RegisterSuccess from "@/views/frontViews/components/registerSuccess";
import WechatBind from "@/views/frontViews/components/wechatBind";
import ForgetPassword from "@/views/frontViews/components/forgetPassword";
//import MainIndex from "@/views/mainIndex";
const MainIndex = () => import("@/views/mainIndex");
const ProvideStore = () => import("@/views/juYuanStore");
// import NSQspeed from "@/views/frontViews/NSQspeed";
import Service from "@/views/frontViews/service";
import ServiceDetail from "@/views/frontViews/serviceDetail";
import cooperate from "@/views/frontViews/cooperate";
import ServiceApply from "@/views/frontViews/serviceApply";
import ConfirmOrder from "@/views/frontViews/confirmOrder"; //订单确认
import payment from "@/views/frontViews/payment"; //订单支付
import orderPaySuccess from "@/views/frontViews/orderPaySuccess"; //订单支付
import Layout from "@/views/frame/Layout.vue";
import ServiceProduct from "@/views/frontViews/product/serviceProduct";
import ConsoleMain from "@/views/consoleViews/consoleMain";
import workOrder from "@/views/frontViews/workOrder";
import SubmitWorkOrder from "@/views/frontViews/submitWorkOrder";
import SubmitWorkOrderSuccess from "@/views/frontViews/submitWorkOrderSuccess";
import SubmitAppeal from "@/views/frontViews/submitAppeal";
import SubmitAppealSuccess from "@/views/frontViews/submitAppealSuccess";

//开发者云大会
import DeveloperConference from "@/views/frontViews/developerConference/developerConference";
import Ticketing from "@/views/frontViews/developerConference/ticketing";
import MeetingAgenda from "@/views/frontViews/developerConference/meetingAgenda";
import PaySuccess from "@/views/frontViews/developerConference/paySuccess";
import Guests from "@/views/frontViews/developerConference/guests";
import ConferenceIndex from "@/views/frontViews/developerConference/conferenceIndex";
import MainForum from "@/views/frontViews/developerConference/mainForum";
import SubForum from "@/views/frontViews/developerConference/subForum";
import CloudMeeting from "@/views/frontViews/developerConference/cloudMeeting";
import TicketType from "@/views/frontViews/developerConference/ticketType";
import Activity from "@/views/frontViews/developerConference/activity";

// 杭州市金融系统职工技能大赛
import FinancialCompetitionMain from "@/views/financialCompetitionViews/index";

//2022 玩转10月运营活动
// import activityIndex from "@/views/activities/octoberWelfare/octoberWelfare.vue";
import activityIndex from "@/views/activities/novemberWelfare/novemberWelfare.vue";
//线索征集活动
import opportunityCollectActivity from "@/views/activities/opportunityCollect/opportunityCollectActivity";
import broadcast_one from "@/views/activities/broadcast/broadcast_one.vue";
import broadcast_two from "@/views/activities/broadcast/broadcast_two.vue";
//热门组件活动
import apiActivity from "@/views/activities/apiActivity/apiActivity.vue";
//学习之星活动
import learningStar from "@/views/activities/learningStar/learningStar.vue";
//U+
import UplusHome from "@/views/uPlus/index";

import serviceHome from "@/views/uPlus/service";
import { login, CASLoginAPI, isLogin } from "@/api/login";
import { toLogin, removeTicket } from "@/utils";
import { inMobile } from "@/const";
import store from "@/store";
/* form */
const BasicForm = _import("form/basicForm");
const stepForm = _import("form/stepForm");
const AdvancedForm = _import("form/advancedForm");
/* list */
// const TableList = _import('list/tablelist');
// const BasicList = _import('list/basiclist');
// const CardList = _import('list/cardlist');
// const Articles = _import('list/articles');
// const Projects = _import('list/projects');
// const Application = _import('list/application');
/* result */
const Basic = _import("profile/basic");
const Advanced = _import("profile/advanced");
/* result */
const Success = _import("result/success");
const Fail = _import("result/fail");
/* error page */
const Err403 = _import("error/403");
const Err404 = _import("error/404");
const Err500 = _import("error/500");
const BigDataSelect = _import("demo/bigDataSelect");
const BigDataTable = _import("demo/bigDataTable");
const TableSearch = _import("demo/tableSearch");
const TableSelect = _import("demo/tableSelect");
Vue.use(Router);

/* 路由模板 */
const rout = {
  template: "<router-view></router-view>"
};

const host = location.hostname;
/* 常量路由 */
export const constantRouterMap = [
  {
    path: "/login",
    component: Login,
    name: "登录",
    hidden: true,
    children: [
      {
        path: "wechatBind",
        component: WechatBind,
        name: "微信绑定手机"
      }
    ]
  },
  {
    path: "/forgetPassword",
    component: ForgetPassword,
    name: "忘记密码"
  },
  {
    path: "/register",
    component: Register,
    name: "注册",
    hidden: true,
    children: [
      {
        path: "registerSuccess",
        component: RegisterSuccess,
        name: "注册成功"
      }
    ]
  },
  {
    path: "/",
    name: "pc端首页",
    component:
      window.ProviderStoreHostMap && window.ProviderStoreHostMap[host]
        ? ProvideStore
        : MainIndex,
    meta: {
      moduleClassify: "门户首页",
      moduleSecondaryClassify: "pc端首页",
      header:
        window.ProviderStoreHostMap && window.ProviderStoreHostMap[host]
          ? false
          : true,
      hideCustCare: true,
      isHomePage: true
    }
    //hidden: true,
    // children: [
    //   {
    //     path: "mainIndex",
    //     component: MainIndex,
    //     meta: {
    //       header: true
    //     },
    //     name: "首页"
    //   }
    // ]
  },
  {
    path: "/mainIndex",
    component: MainIndex,
    meta: {
      header: true,
      moduleClassify: "门户首页",
      moduleSecondaryClassify: "pc端首页",
      hideCustCare: true,
      isHomePage: true
    },
    name: "首页"
  },
  {
    path: "/uPlus",
    component: UplusHome,
    meta: {
      header: true,
      moduleClassify: "门户首页",
      moduleSecondaryClassify: "了解U+"
    },
    name: "了解U+"
  },
  {
    path: "/newPage",
    name: "空白页",
    component: () => import("@/views/uPlus/newPage"),
    meta: {
      header: false
    }
  },
  {
    path: "/inviteResult",
    name: "邀请结果",
    component: () => import("@/views/frontViews/inviteResult"),
    meta: {
      requireAuth: true,
      header: true
    }
  },
  {
    path: "/enterAccountTransfer",
    name: "企业账号移交",
    component: () => import("@/views/frontViews/enterAccountTransfer"),
    meta: {
      requireAuth: true,
      header: true
    }
  },
  {
    path: "/activateInvite",
    name: "激活个人账号",
    component: () => import("@/views/frontViews/activateInvite"),
    meta: {
      requireAuth: false,
      header: true
    }
  },
  {
    path: "/exportUserinfo",
    name: "导出个人信息",
    component: () => import("@/views/frontViews/exportUserinfo"),
    meta: {
      requireAuth: true,
      header: true
    }
  },
  {
    path: "/serviceHome",
    component: serviceHome,
    meta: {
      header: true,
      moduleClassify: "服务",
      moduleSecondaryClassify: "增值服务"
    },
    name: "增值服务"
  },
  {
    path: "/workOrder",
    name: "工单",
    component: workOrder,
    requireAuth: true,
    meta: {
      requireAuth: true,
      header: true
    },
    children: [
      {
        path: "submitAppeal",
        name: "申述",
        component: SubmitAppeal,
        meta: {
          requireAuth: false,
          header: true,
          moduleClassify: "公共服务",
          moduleSecondaryClassify: "申述"
        }
      },
      {
        path: "submitAppealSuccess",
        component: SubmitAppealSuccess,
        name: "提交申述成功",
        meta: {
          header: true,
          requireAuth: false,
          moduleClassify: "公共服务",
          moduleSecondaryClassify: "申述"
        }
      },
      {
        path: "SubmitWorkOrder",
        name: "提交工单",
        component: SubmitWorkOrder,
        meta: {
          requireAuth: true,
          header: true,
          requireAuth: true,
          moduleClassify: "公共服务",
          moduleSecondaryClassify: "工单"
        }
      },
      {
        path: "submitWorkOrderSuccess",
        component: SubmitWorkOrderSuccess,
        name: "提交工单成功",
        meta: {
          requireAuth: true,
          header: true,
          requireAuth: true,
          moduleClassify: "公共服务",
          moduleSecondaryClassify: "工单"
        }
      }
    ]
  },
  // {
  //   path: "/NSQspeed",
  //   component: NSQspeed
  //   //hidden: true
  // },
  {
    path: "/serviceProduct",
    name: "云市场",
    component: () => import("@/views/cloudMarket/index"),
    redirect: "/serviceProduct/home",
    meta: {
      header: true,
      moduleClassify: "产品",
      moduleSecondaryClassify: "组件市场"
    },
    children: [
      // {
      //   path: "/serviceProduct/home",
      //   name: "云市场首页",
      //   component: () => import("@/views/cloudMarket/home/index"),
      //   meta: {
      //     header: true,
      //     moduleClassify: "产品",
      //     moduleSecondaryClassify: "组件市场"
      //   }
      // },
      {
        path: "/serviceProductAll",
        name: "serviceProductAll",
        component: () => import("@/views/cloudMarket/marketAll/index"),
        meta: {
          header: true,
          moduleClassify: "产品",
          moduleSecondaryClassify: "组件市场"
        }
      },
      {
        path: "/searchResult",
        name: "搜索结果",
        component: () => import("@/views/cloudMarket/searchResult/index"),
        meta: {
          header: true,
          moduleClassify: "产品",
          moduleSecondaryClassify: "组件集市-搜索结果页"
        }
      }
    ]
  },
  {
    path: "/product",
    name: "产品",
    component: () => import("@/views/product/index"),
    meta: {
      header: true,
      moduleClassify: "产品",
      moduleSecondaryClassify: "组件市场"
    }
  },
  {
    path: "/productDerils",
    name: "产品详情",
    component: () => import("@/views/product/productDerils/productDerils"),
    meta: {
      header: true,
      moduleClassify: "产品",
      moduleSecondaryClassify: "组件市场"
    }
  },
  {
    path: "/service",
    name: "LIGHT云",
    component: Service,
    meta: {
      header: true
    },
    children: [
      {
        path: "serviceDetail/:id",
        component: ServiceDetail,
        meta: {
          header: true,
          moduleClassify: "产品",
          moduleSecondaryClassify: "组件市场"
        },
        name: "组件详情",
        children: [
          {
            path: "apply/:cid",
            component: ServiceApply,
            name: "申请使用 ",
            meta: {
              footerShow: false,
              requireAuth: true,
              header: true,
              moduleClassify: "产品",
              moduleSecondaryClassify: "组件市场"
            }
          },
          {
            path: "confirmOrder/:cid",
            component: ConfirmOrder,
            name: "购买服务",
            meta: {
              footerShow: false,
              requireAuth: true,
              header: true,
              moduleClassify: "产品",
              moduleSecondaryClassify: "组件市场"
            }
          },
          {
            path: "payment",
            component: payment,
            name: "订单支付",
            meta: {
              footerShow: false,
              requireAuth: true,
              header: true,
              moduleClassify: "产品",
              moduleSecondaryClassify: "组件市场"
            }
          },
          {
            path: "orderPaySuccess",
            component: orderPaySuccess,
            name: "订单支付成功",
            meta: {
              footerShow: false,
              requireAuth: true,
              header: true,
              moduleClassify: "产品",
              moduleSecondaryClassify: "组件市场"
            }
          }
        ]
      },
      {
        path: ":type",
        component: cooperate,
        meta: {
          header: true
        },
        name: "虚商",
        hidden: true
      }
    ]
  },
  {
    path: "/marketCalendar",
    name: "行情日历",
    component: () => import("@/views/marketPortal/marketCalendar"),
    children: [
      {
        path: "marketNewsDetail",
        name: "网站公告",
        component: () => import("@/views/marketPortal/marketNewsDetail")
      }
    ]
  },
  {
    path: "/developer",
    name: "开发者",
    component: () => import("@/views/developer/developer"),
    meta: {
      header: true
    }
  },
  {
    path: "/training",
    name: "培训",
    component: () => import("@/views/training/index"),
    redirect: "/training/lightTraining",
    children: [
      {
        path: "lightTraining",
        name: "light培训"
        // component: () => import("@/views/training/lightTraining"),
      }
    ]
  },
  // {
  //   path: "/solution",
  //   name: "解决方案",
  //   component: () => import("@/views/solution/home"),
  //   meta: {
  //     header: true
  //   }
  // },
  // 上海恒生聚源数据服务有限公司 店铺页面
  {
    path: "/provide-store/:id",
    name: "店铺模板",
    component: () => import("@/views/juYuanStore")
  },
  {
    path: "/console",
    name: "控台首页",
    component: ConsoleMain,
    meta: {
      invoice: true,
      sideBar: false,
      requireAuth: true
    },
    children: [
      {
        path: "myCertificate",
        name: "我的证书",
        meta: {
          invoice: true,
          sideBar: false,
          activeName: "1-4",
          requireAuth: true
        },
        component: () =>
          import("@/views/consoleViews/vitrualBusiness/myCertificate")
      },
      {
        path: "myMessage",
        name: "我的消息",
        meta: {
          invoice: true,
          sideBar: false,
          activeName: "7",
          requireAuth: true
        },
        component: () =>
          import("@/views/consoleViews/vitrualBusiness/myMessage")
      }
    ]
  },
  {
    path: "/developerConference",
    name: "开发者云大会",
    component: DeveloperConference,
    redirect: "/developerConference/conferenceIndex",
    meta: {
      title: "2021LIGHT开发者云大会",
      sideBar: false
    },
    children: [
      {
        path: "conferenceIndex",
        component: ConferenceIndex,
        name: "会议首页",
        meta: {
          title: "2021LIGHT开发者云大会",
          // 控制光子中心按钮显示与否，false不显示
          sideBar: false
        },
        beforeRouteLeave(to, from, next) {}
      },
      {
        path: "cloudMeeting",
        component: CloudMeeting,
        name: "云会场",
        meta: {
          title: "2021LIGHT开发者云大会",
          // 控制光子中心按钮显示与否，false不显示
          sideBar: false
        }
      },
      {
        path: "ticketing",
        component: Ticketing,
        name: "购票服务",
        meta: {
          requireAuth: true,
          title: "2021LIGHT开发者云大会",
          sideBar: false
        }
      },
      {
        path: "meetingAgenda",
        component: MeetingAgenda,
        name: "大会议程",
        meta: {
          title: "2021LIGHT开发者云大会",
          sideBar: false
        }
      },
      {
        path: "paySuccess",
        component: PaySuccess,
        name: "付款成功页",
        meta: {
          title: "2021LIGHT开发者云大会",
          sideBar: false
        }
      },
      {
        path: "guests",
        component: Guests,
        name: "大会嘉宾",
        meta: {
          title: "2021LIGHT开发者云大会",
          sideBar: false
        }
      },
      {
        path: "mainForum",
        component: MainForum,
        name: "主论坛",
        meta: {
          title: "2021LIGHT开发者云大会",
          sideBar: false
        }
      },
      {
        path: "subForum",
        component: SubForum,
        name: "技术分论坛",
        meta: {
          title: "2021LIGHT开发者云大会",
          sideBar: false
        }
      },
      {
        path: "activity",
        component: Activity,
        name: "同期活动",
        meta: {
          title: "2021LIGHT开发者云大会",
          sideBar: false
        }
      },
      {
        path: "cloudShow",
        component: () =>
          import("@/views/frontViews/developerConference/cloudShow.vue"),
        name: "云上展厅",
        meta: {
          title: "2021LIGHT开发者云大会",
          sideBar: false
        }
      }
    ]
  },
  {
    path: "/competition",
    name: "技术争霸赛",
    meta: {
      sideBar: false,
      requireAuth: true
    },
    component: () => import("@/views/competitionViews/index")
  },
  {
    path: "/financial-competition",
    name: "2022杭州市金融系统云技术职工技能大赛",
    meta: {
      sideBar: false
    },
    component: FinancialCompetitionMain
  },
  {
    path: "/activityIndex",
    name: "2022玩转10月活动攻略",
    meta: {
      footerShow: false,
      requireAuth: true,
      moduleClassify: "运营",
      moduleSecondaryClassify: "活动"
    },
    component: activityIndex
  },
  {
    path: "/broadcastAlive",
    name: "直播不打烊",
    meta: {
      sideBar: false,
      footerShow: false,
      requireAuth: true,
      moduleClassify: "运营",
      moduleSecondaryClassify: "活动"
    },
    component: broadcast_one
  },
  {
    path: "/broadcastWelfare",
    name: "U+直播间20万福利季",
    meta: {
      sideBar: false,
      footerShow: false,
      requireAuth: true,
      moduleClassify: "运营",
      moduleSecondaryClassify: "活动"
    },
    component: broadcast_two
  },
  {
    path: "/apiActivity",
    name: "组件0元试用活动",
    meta: {
      sideBar: false,
      footerShow: false,
      requireAuth: true,
      moduleClassify: "运营",
      moduleSecondaryClassify: "活动"
    },
    component: apiActivity
  },
  {
    path: "/learningStar",
    name: "年度学习之星",
    meta: {
      sideBar: false,
      footerShow: false,
      requireAuth: true,
      moduleClassify: "运营",
      moduleSecondaryClassify: "活动"
    },
    component: learningStar
  },
  {
    path: "/opportunityCollect",
    name: "线索征集活动",
    meta: {
      sideBar: false,
      footerShow: false,
      requireAuth: true,
      moduleClassify: "运营",
      moduleSecondaryClassify: "活动"
    },
    component: opportunityCollectActivity
  },
  // 上海恒生聚源数据服务有限公司 店铺页面
  {
    path: "/productList",
    name: "产品的列表",
    component: () => import("@/views/productSolution/productList.vue"),
    meta: {
      header: false,
      moduleClassify: "产品",
      moduleSecondaryClassify: "产品"
    }
  },
  {
    path: "/productModule",
    name: "产品的模块",
    component: () =>
      import("@/views/productSolution/productModule/productModule.vue"),
    meta: {
      header: false,
      requireAuth: false,
      moduleClassify: "产品",
      moduleSecondaryClassify: "产品"
    }
  },
  {
    path: "/productDetail",
    name: "产品的详情",
    component: () =>
      import("@/views/productSolution/productDetail/productDetail.vue"),
    meta: {
      header: false,
      requireAuth: false,
      moduleClassify: "产品",
      moduleSecondaryClassify: "产品"
    }
  },
  {
    path: "/solutionList",
    name: "解决方案列表",
    component: () => import("@/views/productSolution/solutionList.vue"),
    meta: {
      header: false,
      moduleClassify: "产品",
      moduleSecondaryClassify: "解决方案"
    }
  },
  {
    path: "/solutionDetail",
    name: "解决方案详情",
    component: () =>
      import("@/views/productSolution/solutionDetail/solutionDetail.vue"),
    meta: {
      header: false,
      requireAuth: true,
      moduleClassify: "产品",
      moduleSecondaryClassify: "解决方案"
    }
  },
  {
    path: "/uplusLive",
    name: "直播",
    component: () => import("@/views/uplusLive/index/index.vue"),
    meta: {
      header: false,
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "直播"
    }
  },
  {
    path: "/uplusLiveDetail",
    name: "直播详情",
    component: () => import("@/views/uplusLive/detail/detail.vue"),
    meta: {
      header: false,
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "直播"
    }
  },
  {
    path: "/uplusLivePlay",
    name: "直播播放",
    component: () => import("@/views/uplusLive/livePlay/livePlay.vue"),
    meta: {
      header: false,
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "直播"
    }
  },
  {
    path: "/uplusLivePush",
    name: "服务号绑定推送",
    component: () => import("@/views/uplusLive/push/index.vue"),
    meta: {
      header: false,
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "直播"
    }
  },
  {
    path: "*",
    component: Err404,
    name: "404",
    meta: {
      header: true
    }
  },
  {
    path: "/clueIndex",
    name: "线索登记奖励",
    component: () => import("@/views/clue/index/clueIndex.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "线索登记",
      moduleSecondaryClassify: "首页"
    }
  },
  ...courseRouter
];

/* 异步路由 */
export const asyncRouterMap = [
  {
    path: "/exception",
    redirect: "/exception/403",
    component: Layout,
    icon: "warning",
    name: "异常",
    children: [
      {
        path: "403",
        component: Err403,
        name: "403"
      },
      {
        path: "404",
        component: Err404,
        name: "404"
      },
      {
        path: "500",
        component: Err500,
        name: "500"
      }
    ]
  }
];

const router = new Router({
  mode: "history",
  base: "/openplat-front",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});

router.beforeEach(handleRouterChange);
export default router;

// 初始化路由跳转
function handleRouterChange(to, from, next) {
  // 地址示例：http://localhost/cloud-console/myService/renewManage?expire=15&ticket=ST-370-eHlGZCCSjglWoZ6gzWYQ-dev_iuc_cas_server
  const arr = location.href.split("?ticket=");
  const arr1 = location.href.split("&ticket=");
	const { redirectInMobile } = to.meta
	// 如果配置了手机访问的时候重定向，不用进行登录等操作了，直接执行next即可【在目标页面中会做重定向到移动端页面的操作】
	if (redirectInMobile && inMobile) {
		next()
		return
	}
  let result = [];
  // 地址上面只有ticket参数
  if (arr.length === 2) {
    result = arr;
  }
  // 地址上面除ticket外还有其他参数【这些参数只会在tikcet前面】
  if (arr1.length === 2) {
    result = arr1;
  }
  // 如果页面地址上面有ticket说明是从登录页面跳转过来的，那么直接进行本系统的登录
  if (result[1]) {
    let params = {
      ticket: result[1],
      service: result[0]
    };
    doLogin(params, next, to);
  } else {
    // 否则走正常的页面跳转流程
    const { requireAuth } = to.meta;
    // 调用isLogin接口，获取原light相关信息，以便能够保持到vuex中
    isLogin()
      .then(res => {
        // 登录了，那么直接获取个人信息保持到vuex中
        if (res.login) {
          store.commit("SET_USER", res);
          next();
          Vue.prototype.$setUplusUser(to);
        } else {
          // 已登录的情况下直接跳转
          // if (token) {
          //   next();
          //   Vue.prototype.$setUplusUser();
          // } else {
          // 未登录的情况下
          // 页面需要登录直接跳转到登录页面
          if (requireAuth) {
            toLogin();
            // 页面不需要登录，那么进行登录信息的同步
          } else {
            loginSync(next);
          }
          // }
        }
      })
      .catch(() => {
        next();
      });
  }
}

// 登录本系统
function doLogin(params, next, to) {
  login(params)
    .then(res => {
      if (!res) {
        // 登录失败，退出，重新跳转登录页面
        // window.consoleHeaderConfig.consoleLogout()
      }
      if (res.access_token) {
        // 如果是通过iframe嵌入的形式登录的，那么登录成功后更新父页面的状态
        window.sessionStorage.setItem("Access-Token", res.access_token);
        window.localStorage.setItem("Access-Token", res.access_token);
        const parent = window.parent;
        // 如果是在内嵌的iframe中成功登录
        if (parent !== window) {
          parent.newWebSitVm.$setUplusUser(to);
        } else {
          // 如果是正常页面登录成功
          window.newWebSitVm.$setUplusUser(to);
        }
      }
      jumpAfterLogin(to, next)
    })
    .catch(err => {
      console.log(err);
      jumpAfterLogin(to, next)
    });
}

// 同步登录信息
function loginSync(next) {
  CASLoginAPI().then(res => {
    const unifiedAuthIsLogin = res.data ? res.data.loginFlag : false; // 统一认证是否登录
    // 统一认证登录了那么进行单点登录
    if (unifiedAuthIsLogin) {
      toLogin(window.location.href, true); // 单点登录
    }
    next();
  });
}

// 登录后跳转
function jumpAfterLogin(to, next) {
  const url = window.location.href;
  const { path } = to || {};
  // 地址中有ticket并且页面不是课堂播放器页面的话，需要去掉地址上面的ticket【课堂播放器页面中有移除ticket的方法，为了防止会冲突，所以非播放器页面才在此处移除ticket】
  if (url.indexOf("ticket") > -1 && path.indexOf("coursePlay") === -1) {
    next();
    setTimeout(() => {
      history.replaceState(null, null, removeTicket(url));
    }, 100);
  } else {
    next();
  }
}



// WEBPACK FOOTER //
// ./src/gtn/router/index.js